import { createSelector } from "reselect";

const getMilesPerCurrency = state => state.brand?.milesPerCurrency;
const getMilesPerCurrencyOverrides = state => state.miles?.milesPerCurrency;
const getCurrency = state => state.currency;

// Normalise un ratio { currencyAmount, milesAmount } en un nombre directement
// applicable à un prix. Retourne null si la donnée est manquante ou invalide.
const normalizeMilesRatio = raw => {
	if (raw === null || raw === undefined) {
		return null;
	}
	const { currencyAmount, milesAmount } = raw;
	if (!currencyAmount || milesAmount === null || milesAmount === undefined) {
		return null;
	}
	return milesAmount / currencyAmount;
};

// Retourne le ratio miles-par-unité-de-devise à appliquer pour la shop courante.
// Logique de fallback : override shop pour la devise courante -> valeur brand.
export const getMilesRatio = createSelector(
	[getMilesPerCurrency, getMilesPerCurrencyOverrides, getCurrency],
	(brandMilesPerCurrency, shopOverrides, currency) => {
		const override = Array.isArray(shopOverrides)
			? shopOverrides.find(item => item?.currency === currency)
			: null;

		const shopRatio = normalizeMilesRatio(override);
		if (shopRatio !== null) {
			return shopRatio;
		}

		return normalizeMilesRatio(brandMilesPerCurrency);
	}
);
